import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

import Progress from "react-progress-2";
import { toast } from "react-hot-toast";
import CardHeader from "../../components/common/CardHeader";
import CardBody from "../../components/common/CardBody";
import ProductImage from "../../components/common/ProductImage";
import ViewButton from "../../components/common/ViewButton";
import DeleteButton from "../../components/common/DeleteButton";
import CheckPermission from "../../components/roles/CheckPermission";
import { privateApi } from "../../api";

const ProductEnquiryList = () => {
      const [loading, setLoading] = useState(false);
      const [enquiries, setEnquiries] = useState([]);
      const [totalData, setTotalData] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState("");

      const loadData = async () => {
            setLoading(true);
            await privateApi
                  .get(
                        `/dashboard/product_enquiries?limit=${limit}&search=${search}`
                  )
                  .then((response) => {
                        setEnquiries(response.data.enquiries);
                        setTotalData(response.data.totalItems);
                        setPerPages(response.data.perPages);
                        setCurrentPage(response.data.currentPage);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, [limit, search]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            setLoading(true);
            Progress.show();
            const url = `/dashboard/product_enquiries?page=${pageNumber}&limit=${limit}&search=${search}`;
            await privateApi(url)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setEnquiries(response.data.enquiries);
                              setTotalData(response.data.totalItems);
                              setPerPages(response.data.perPages);
                              setCurrentPage(response.data.currentPage);
                        }
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      }

      const handleDelete = async (faq) => {
            const response = await privateApi
                  .delete(`/dashboard/product_enquiries/${faq.slug}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setEnquiries((enquiries) =>
                                    enquiries.filter(
                                          (item) => item.id !== faq.id
                                    )
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Product Enquiry List" />
                                    <CardBody
                                          totalItems={totalData}
                                          perPages={perPages}
                                          setLimit={setLimit}
                                          currentPage={currentPage}
                                          getData={getData}
                                          setSearch={setSearch}
                                    >
                                          <thead>
                                                <tr>
                                                      <th
                                                            className="text-center"
                                                            width="80px"
                                                      >
                                                            #
                                                      </th>
                                                      <th>Name</th>
                                                      <th>Product details</th>
                                                      <th>Contact details</th>
                                                      <th width="120px">
                                                            Action
                                                      </th>
                                                </tr>
                                          </thead>

                                          <tbody>
                                                {!loading ? (
                                                      enquiries.length > 0 ? (
                                                            enquiries.map(
                                                                  (
                                                                        item,
                                                                        index
                                                                  ) => (
                                                                        <>
                                                                              <tr
                                                                                    key={
                                                                                          index
                                                                                    }
                                                                              >
                                                                                    <td className="text-center">
                                                                                          {
                                                                                                item.index
                                                                                          }
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      item.name
                                                                                                }
                                                                                                category={`On: ${item.date}`}
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      item
                                                                                                            ?.product
                                                                                                            ?.title
                                                                                                }
                                                                                                image={
                                                                                                      item
                                                                                                            ?.product
                                                                                                            ?.image
                                                                                                }
                                                                                                category={`Brand: ${item.product?.brand_name}`}
                                                                                          />
                                                                                    </td>
                                                                                    <td>
                                                                                          <ProductImage
                                                                                                title={
                                                                                                      item.phone_number
                                                                                                }
                                                                                                category={`Email: ${item.email}`}
                                                                                          />
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                          <ViewButton
                                                                                                link={`/dashboard/product_enquiries/${item.slug}/show`}
                                                                                          />
                                                                                          <CheckPermission permission="product-enquiry-delete">
                                                                                                <DeleteButton
                                                                                                      item={
                                                                                                            item
                                                                                                      }
                                                                                                      loading={
                                                                                                            loading
                                                                                                      }
                                                                                                      setLoading={
                                                                                                            setLoading
                                                                                                      }
                                                                                                      handleDelete={
                                                                                                            handleDelete
                                                                                                      }
                                                                                                />
                                                                                          </CheckPermission>
                                                                                    </td>
                                                                              </tr>
                                                                        </>
                                                                  )
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    7
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              No
                                                                              Enquiry
                                                                              Found
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )
                                                ) : (
                                                      <>
                                                            <tr>
                                                                  <td
                                                                        colSpan={
                                                                              7
                                                                        }
                                                                        className="text-center"
                                                                  >
                                                                        Loading...
                                                                  </td>
                                                            </tr>
                                                      </>
                                                )}
                                          </tbody>
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default ProductEnquiryList;
